export default {
  settings: {
    mimeType: 'application/ld+json',
    corsEnabled: false
  },
  environments: {
    staging: 'https://search.staging-api.immediate.co.uk',
    preproduction: 'https://search.preproduction-api.immediate.co.uk',
    production: 'https://search.api.immediate.co.uk'
  },
  endpoints: {
    search: {
      endpoint: '/v4/search'
    },
    searchv5: {
      endpoint: '/v5/search',
      appendClientToEndpoint: true,
      appendLanguage: true
    },
    searchv5Documents: {
      endpoint: '/v5/search_documents'
    },
    batch: {
      endpoint: '/v5/batch'
    }
  }
};